export default __webpack_public_path__ + "static/media/about-page.6c03aae5e7ea793ec4eb9f4dccfa2dc3.svg";